import styled from 'styled-components';
export const FolderList = styled.ul`
  list-style: none;
  padding: 0;
`;
export const BackItem = styled.section`
  text-align: right;
`;